import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import { useAction } from '../utils/react-redux'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import { withOnlyPE } from '../Device'
import { selectGeolocationPosition, selectIsGeoLocationOn } from '../../store/map/map.selectors'
import s from './ETA.less'
import { computeETAFromGeoloc } from '../../store/itinerary/itinerary.actions'
import { getRouteTimeLabel, getRouteLengthLabel } from '../../store/itinerary/routes.selectors'
import SVGIcon from '../svg/SVGIcon'
import StepUpNumber from '../genericComponents/StepUpNumber'
import { selectSelectedLocationCoordinates } from '../../store/location/location.selectors'
import { useSelector } from 'react-redux'
import { locationHasCoords } from '../utils/location'

const useResetRouteOnCoordinatesChanged = (setRoute, locationCoords) => {
  useEffect(() => {
    setRoute(undefined)
  }, [locationCoords])
}

const useETARoute = () => {
  const [route, setRoute] = useState(null)

  const execComputeETAFromGeoloc = useAction(computeETAFromGeoloc)

  const isGeoLocationEnabled = useSelector(selectIsGeoLocationOn)
  const geolocationPosition = useSelector(selectGeolocationPosition)
  const locationCoords = useSelector(selectSelectedLocationCoordinates)

  useResetRouteOnCoordinatesChanged(setRoute, locationHasCoords)

  useEffect(() => {
    if (locationCoords && isGeoLocationEnabled && geolocationPosition) {
      execComputeETAFromGeoloc(locationCoords).then(route => setRoute(route))
    }
  }, [isGeoLocationEnabled, geolocationPosition, locationCoords])

  return route
}

export const ETA = () => {
  const route = useETARoute()

  return (
    <div className={classNames(s.ETA, !route && s.empty)}>
      {route && (
        <span className={s.icon}>
          <SVGIcon icon={route?.icon} />
        </span>
      )}
      <span className={s.length}>
        <StepUpNumber label={getRouteLengthLabel(route)} mainClassName={s.bigNumber} restClassName={s.rest} />
      </span>
      <span className={s.time}>
        <StepUpNumber label={getRouteTimeLabel(route)} mainClassName={s.bigNumber} restClassName={s.rest} />
        <span className={s.waves}>
          <SVGIcon icon="real-time" />
        </span>
      </span>
    </div>
  )
}

export default withOnlyPE(withEmptyFallbackErrorBoundary(ETA))
